export default __webpack_public_path__ + "static/media/bailey_sign_350.9a659267.webp";